import { observable, action } from "mobx";
import uuid from "uuid";
import Validation from "../utils/Validation";

class Immersive3dTourFloor extends Validation {
  @observable id = null;

  @observable name = "";

  @observable panoramas = [];

  @observable error = null;

  constructor({ id = null, name = "", panoramas = [] }) {
    super();
    this.id = id || uuid();
    this.name = name;
    this.panoramas = panoramas;
  }

  hasPanoramaId(panoramaId) {
    return this.getPanoramaId(panoramaId) !== null;
  }

  getPanoramaId(panoramaId) {
    const index = this.panoramas.findIndex(panorama => panorama.id === panoramaId);

    if (index !== -1) {
      return this.panoramas[index];
    }

    return null;
  }

  panoramaIndex(panorama) {
    return this.panoramas.findIndex(o => o === panorama);
  }

  internalValidates() {
    this.panoramas.forEach(panorama => {
      if (panorama.hasValidationMessages) {
        panorama.validationMessage.forEach(validationMessage => {
          this.addValidationMessage(validationMessage.message, validationMessage.type);
        });
      }
    });
  }

  @action
  addPanorama(panorama) {
    this.panoramas.push(panorama);
    this.validates();
  }

  @action
  addPanoramaAtIndex(panorama, index) {
    this.panoramas.splice(index, 0, panorama);
    this.validates();
  }

  @action
  removePanoramaAtIndex(index) {
    this.panoramas.splice(index, 1);
    this.validates();
  }

  @action
  removePanoramaWithId(panoramaId) {
    this.panoramas = this.panoramas.filter(panorama => panorama.id !== panoramaId);
    this.validates();
  }

  @action
  setName(name) {
    this.name = name;
  }

  @action
  setError(error) {
    this.error = error;
  }

  @action
  setPanoramas(panoramas) {
    this.panoramas = panoramas;
  }
}

export default Immersive3dTourFloor;
